import React, { useState, useContext, useEffect } from "react";
import { useLazyQuery } from "@apollo/react-hooks";

import { client } from "../../../../services/constants";
import {
    GET_SEARCH_COLLECTIONS,
    GET_SEARCH_KEYWORDS_COLLECTIONS,
} from "../../../../services/graphql-query";
import Collections from "../../common-components/Collections";
import MainContext from "../../../../context/Main";
import ProductPlaceholder from "../../common-components/Placeholders";
import SearchSubtitle from "./SearchSubtitle";

export default function CollectionSearch({
    search,
    onEmptySearch = (f) => f,
    isEmpty,
}) {
    const [collections, setCollections] = useState(null);

    const { totalCollections, keywords } = useContext(MainContext);

    const [
        getCollections,
        {
            loading: collectionsLoading,
            error: collectionsError,
            data: collectionsData,
            startPolling,
            stopPolling,
        },
    ] = useLazyQuery(GET_SEARCH_COLLECTIONS, {
        variables: { partName: search, limit: totalCollections },
        onCompleted: async (res) => {
            if (!keywords) startPolling(2000);
            else {
                if (stopPolling) stopPolling();

                const collectionsByKeywords = await getCollectionsByKeyword();

                const union = [
                    ...collectionsByKeywords,
                    ...res.collections.data,
                ]
                    .filter((p) => {
                        return p;
                    })
                    .filter(
                        (value, index, self) =>
                            index === self.findIndex((t) => t.id === value.id)
                    ); // if the same id removes the extra
                setCollections(union);
            }
        },
    });

    useEffect(() => {
        if (totalCollections) {
            getCollections();
        }
    }, [totalCollections]);

    async function getCollectionsByKeyword() {
        let keywordFilter = "";
        keywords.map((k) => {
            keywordFilter += `{ name: { containsi: \"${k.attributes.keyword}\" } }\n`;
        });

        const resultByKeywords = await client.query({
            query: GET_SEARCH_KEYWORDS_COLLECTIONS(keywordFilter),
        });

        return resultByKeywords.data.collections.data;
    }

    return (
        <>
            {collectionsLoading && !isEmpty && (
                <>
                    <h1 className="row placeholder-glow">
                        <span className="col-3 placeholder"></span>
                    </h1>
                    <ProductPlaceholder />
                </>
            )}

            {collectionsError ? (
                <SearchSubtitle title="Collections">
                    <p className="lead">
                        An error occurred on the server side. We couldn't load
                        the collections
                    </p>
                </SearchSubtitle>
            ) : (
                collections &&
                collections.length !== 0 && (
                    <SearchSubtitle title="Collections">
                        <Collections collections={collections} />
                    </SearchSubtitle>
                )
            )}
            {collections && collections.length === 0 && onEmptySearch()}
        </>
    );
}
